import React from "react";
import AsyncSelect from "react-select/async";
import "./select.scss";
import { isArray } from "lodash";
import { Check as CheckIcon, UserCircle } from "phosphor-react";

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#F3F3F3" : "white",
    color: state.isSelected ? "#00598B" : "#636363",
    padding: "6px 28px",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "28px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    zIndex: "100",
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    display: "flex",
    width: "100%",
    background: "rgba(15, 15, 15, 0.05)",
    borderRadius: "30px",
    border: "1px solid #ced4da",
    borderColor: state.isFocused ? "#F4C708 !important" : "#ced4da ",
    outline: "none",
    boxShadow: "none",
    zIndex: "100",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    position: "absolute",
  }),
  menuList: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  singleValue: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    gap: "10px",
  }),
};

const CustomOptionComponent = ({ innerRef, innerProps, data }) => (
  <div
    ref={innerRef}
    {...innerProps}
    className="d-flex align-items-center px-3 py-2 custom-option"
    style={{ gap: "12px" }}
  >
    <UserCircle size={24} weight="duotone" className="text-secondary" />

    <div className="d-flex flex-column">
      <span style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
        {data.label}
      </span>
      {data?.cin && (
        <small style={{ fontSize: "14px", color: "#999" }}>({data.cin})</small>
      )}
    </div>
  </div>
);

const CustomSingleValue = ({ data }) => (
  <div className="d-flex align-items-center position-absolute ms-2">
    <UserCircle size={24} weight="duotone" className="text-secondary me-2" />
    <div>
      <span style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
        {data.label}
      </span>
      {data?.cin && (
        <small style={{ fontSize: "14px", color: "#999", marginLeft: "6px" }}>
          ({data.cin})
        </small>
      )}
    </div>
  </div>
);

function ReferralSelectComponent({
  name,
  label,
  className,
  options = [],
  selectedValue,
  handleChange,
  placeholder,
  disabled,
  error,
  dataCallback,
  isMulti,
  isLoading,
  ...rest
}) {
  let value;
  if (isArray(selectedValue)) {
    value = selectedValue;
  } else {
    value = options.find((item) => item.value === selectedValue);
  }

  const loadOptions = async (inputValue, callback) => {
    const fetchedOptions = await dataCallback(inputValue);
    const formattedOptions = fetchedOptions.map((item) => ({
      ...item,
      label: item.name || item.label,
      cin: item.cin || "N/A",
    }));
    callback(formattedOptions);
  };

  return (
    <div className={` ${className ? className : ""} input-otr`}>
      <label htmlFor={name} className="input-label">
        {label}
      </label>
      <div className="select w-100">
        <AsyncSelect
          cacheOptions
          isLoading={isLoading}
          value={value}
          defaultOptions={options}
          width="200px"
          styles={customStyles}
          onChange={handleChange}
          placeholder={placeholder}
          loadOptions={loadOptions}
          closeMenuOnSelect={!isMulti}
          isDisabled={disabled || isLoading}
          className={` ${error ? "border-danger" : ""}`}
          isMulti={isMulti}
          zIndex={100}
          components={{
            SingleValue: CustomSingleValue,
            Option: CustomOptionComponent,
          }}
          {...rest}
        />
      </div>
      {error ? error : null}
    </div>
  );
}

export default ReferralSelectComponent;
